export const outOfStockTooltip = () => {
    $('#layoutProduct .swatch-list li').on('touchstart click', function(e) {
        if ($(this).children('.swatch-disabled').length > 0) {
            $(this).data('title', 'Out of Stock');
            $(this).tooltip('show');
            if ($('.tabletPage').length > 0) {
                let tooltipID = $(this).attr('aria-describedby');
                setTimeout(function() {
                    $(`#${tooltipID}`).remove()
                }, 2000);
            }
        }
    });
    $('#layoutProduct .swatch-list li').on('mouseout', function(e) {
        $(this).tooltip('destroy');
    });
}
